import React from 'react'

const LogoSvg = ({ className }: { className: string }) => (
  <svg data-testid="logo-svg" viewBox="0 0 37 37" fill="none" className={className} />
)

export default LogoSvg
